import 'bootstrap/dist/css/bootstrap.min.css';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import './index.css';

ModuleRegistry.registerModules([AllCommunityModule]);

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
